var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.9998 77V1.00022H1V77H76.9998Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0952 65.5161C24.6617 67.9307 28.6815 69.5958 32.9108 70.4107L33.6679 74.9533C33.8056 75.7797 34.3533 76.4766 35.1912 76.4766H42.8085C43.6464 76.4766 44.1941 75.7797 44.3318 74.9533L45.0889 70.4107C49.3182 69.5958 53.3379 67.9307 56.9045 65.5161L60.6523 68.193C61.3341 68.6801 62.2143 68.7855 62.8066 68.193L68.1929 62.8068C68.7853 62.2145 68.6799 61.3344 68.1929 60.6525L65.5159 56.9047C67.9301 53.3379 69.5952 49.3183 70.4105 45.0891L74.9531 44.332C75.7794 44.1943 76.4764 43.6464 76.4764 42.8087V35.1914C76.4764 34.3536 75.7794 33.8058 74.9531 33.6681L70.4105 32.911C69.5952 28.6818 67.9301 24.6621 65.5159 21.0954L68.1929 17.3476C68.6799 16.6657 68.7853 15.7856 68.1929 15.1933L62.8066 9.80702C62.2143 9.21456 61.3341 9.31998 60.6523 9.80702L56.9045 12.484C53.3379 10.0694 49.3182 8.40422 45.0889 7.58936L44.3318 3.04679C44.1941 2.22048 43.6464 1.52352 42.8085 1.52352H35.1912C34.3533 1.52352 33.8056 2.22048 33.6679 3.04679L32.9108 7.58936C28.6815 8.40422 24.6617 10.0694 21.0952 12.484L17.3474 9.80702C16.6656 9.31998 15.7854 9.21456 15.1931 9.80702L9.80683 15.1933C9.21437 15.7856 9.31994 16.6657 9.80683 17.3476L12.4838 21.0954C10.0696 24.6621 8.40445 28.6818 7.58917 32.911L3.0466 33.6681C2.22029 33.8058 1.52332 34.3536 1.52332 35.1914V42.8087C1.52332 43.6464 2.22029 44.1943 3.0466 44.332L7.58917 45.0891C8.40445 49.3183 10.0696 53.3379 12.4838 56.9047",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23646 76.4766L34.4558 51.2999C37.9917 52.6015 42.0593 52.3833 45.5781 50.3553C50.2442 47.6659 52.6321 42.5508 52.0676 37.5268L41.6362 43.5392L36.3804 40.5098L36.3802 34.4511L46.8118 28.4388C42.7357 25.4388 37.1045 24.9458 32.4383 27.635C26.8094 30.8795 24.4956 37.6539 26.6811 43.5399L1.52332 68.6553",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6208 57.6323C31.7945 59.4001 35.367 60.328 38.9998 60.328C50.779 60.328 60.328 50.7791 60.328 39C60.328 27.2208 50.779 17.6719 38.9998 17.6719C27.2208 17.6719 17.6718 27.2208 17.6718 39C17.6718 42.6221 18.5943 46.1843 20.3522 49.3514",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.3aefade1e968179831aaad1e19dcce8f.svg";
export { ForwardRef as ReactComponent };